import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Kurs.css";
// Keeping imports for fallback or mapping logic, though we might rely on dynamic image from 'rasm' prop.
// 'item.rasm' from backend is './Rasm/html.png'. We can use it directly if we import everything or use dynamic require?
// React src folder restriction: images inside src/Rasm usually can be imported.
// But backend returns path string.
// If we use 'require' context or just <img> tags with imported variabels map.
// Let's create a map for known images to be safe, or try direct path if public?
// The project structure seems to have images in src/Rasm.
// Best approach: Use a helper map based on course name or ID if images are static, OR try to use the path if it resolves (webpack might not like dynamic src unless in public).
// Given the existing imports, let's map them by name or ID if possible.

import html from "../Rasm/html.png";
import css from "../Rasm/css.png";
import js from "../Rasm/js.png";
import bootstrap from "../Rasm/bootstrap.png";
import reactjs from "../Rasm/react.png";
import vue from "../Rasm/vue.png";
import php from "../Rasm/php.png";
import laravel from "../Rasm/laravel.png";
import python from "../Rasm/python.png";
import django from "../Rasm/django.png";
import java from "../Rasm/java.png";
import kotlin from "../Rasm/kotlin.svg";
import swift from "../Rasm/swift.png";
import flutter from "../Rasm/flutter.png";
import mantiq from "../Rasm/mantiq.png";
import mb from "../Rasm/mb.png";
import mi from "../Rasm/mi.png";
import postgresql from "../Rasm/postgresql.png";
// Add missings if any.

import { FaCheckCircle, FaSearch, FaStar } from "react-icons/fa";

// Map for images based on common names or IDs
const imageMap = {
  'HTML': html,
  'CSS': css,
  'JS': js,
  'JavaScript': js,
  'Bootstrap': bootstrap,
  'React JS': reactjs,
  'Vue JS': vue,
  'PHP asoslari': php,
  'php MySQL': php,
  'Laravel': laravel,
  'Python': python,
  'Django': django,
  'Java': java,
  'Kotlin': kotlin,
  'Swift': swift,
  'Flutter': flutter,
  'Algoritm va mantiq': mantiq,
  'Ma\'lumotlar bazasi': mb,
  'Ma\'lumotlar ilmi': mi, // hypothetical
  'Mashinalar ilmi': mi,
  'PostgreSQL': postgresql
};

export default function Kurs({ kurslar, darkMode, toggleUserPanel }) {
  const navigate = useNavigate();
  const handleCourseClick = (nomi) => {
    if (nomi) {
      const slug = nomi.toLowerCase().replace(/ /g, "-");
      navigate(`/kurs-dars/${slug}`);
      if (toggleUserPanel) toggleUserPanel();
    }
  };
  // Filter purchased courses
  const purchasedCourses = Array.isArray(kurslar) ? kurslar.filter(k => k.sotib_olingan) : [];

  const [searchTerm, setSearchTerm] = useState("");

  // Filter based on search
  const filteredCourses = purchasedCourses.filter(item =>
    item.nomi.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Listen for custom events to trigger animation
  React.useEffect(() => {
    const handleSpend = () => {
      const el = document.querySelector('.foydalanuvchi-kurs-asosiy-quti');
      if (el) {
        el.classList.add('spend-animation');
        setTimeout(() => el.classList.remove('spend-animation'), 1000);
      }
    };
    window.addEventListener('spend_coins', handleSpend);
    return () => window.removeEventListener('spend_coins', handleSpend);
  }, []);

  return (
    <div className="foydalanuvchi-kurs-asosiy-quti">
      <div className="foydalanuvchi-kurs-quti">
        <div className="foydalanuvchi-kurs">
          <div className="sarlavha" style={{ color: darkMode ? '#fff' : 'inherit' }}>
            Obuna kurslar
            <span>{filteredCourses.length} dona</span>
          </div>
        </div>
        <div className="foydalanuvchi-kurs-qidiruv">
          <form id="qidiruv-form" onSubmit={(e) => e.preventDefault()}>
            <input
              type="text"
              placeholder="Kurs izlash"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={darkMode ? {
                backgroundColor: '#333',
                color: '#fff',
                border: '1px solid #555'
              } : {}}
            />
            <button type="button">
              <FaSearch />
            </button>
          </form>
        </div>
      </div>

      {/* Render Dynamic Courses */}
      {filteredCourses.length > 0 ? (
        filteredCourses.map((item) => {
          // Calculate Progress
          // Formula: (Total Score) / (Total Topics * 5) * 100
          // Completed: Number of passed lessons

          const totalLessons = item.total_lessons_calc || item.darslar_soni || 1; // avoid div by 0
          const totalPossibleScore = totalLessons * 5;
          const currentScore = item.total_score || 0;

          const percentage = totalPossibleScore > 0 ? (currentScore / totalPossibleScore) * 100 : 0;

          // Stars: 10 stars. Active based on percentage.
          // 10% = 1 star.
          const activeStars = Math.round(percentage / 10);

          // Image fallback
          let courseImg = imageMap[item.nomi] || imageMap[Object.keys(imageMap).find(key => item.nomi.includes(key))] || html;
          // Specific check for some ambiguous names
          if (item.nomi === 'JS') courseImg = js;

          return (
            <div
              className="foydalanuvchi-kurs-qism animate-item"
              key={item.id}
              style={{
                borderColor: darkMode ? '#444' : '#eee',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
              onClick={() => handleCourseClick(item.nomi)}
            >
              <div className="foydalanuvchi-kurs-rasm">
                <img src={courseImg} alt={item.nomi} />
              </div>
              <div className="foydalanuvchi-kurs-bolim">
                <div className="foydalanuvchi-kurs-nomi">
                  <div style={{ color: darkMode ? '#fff' : '#000' }}>{item.nomi}</div>
                  <span style={{ color: darkMode ? '#aaa' : '#888' }}>
                    <FaCheckCircle /> {item.completed_lessons || 0}/{totalLessons}
                  </span>
                </div>
                <div className="foydalanuvchi-kurs-icon">
                  {[...Array(10)].map((_, i) => (
                    <FaStar
                      key={i}
                      style={{ color: i < activeStars ? "#f1c40f" : (darkMode ? '#555' : "#444") }} // Gold for active, Gray for inactive
                    />
                  ))}
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div style={{ padding: '20px', textAlign: 'center', color: darkMode ? '#aaa' : '#888' }}>
          {searchTerm ? "Hech narsa topilmadi" : "Sizda hozircha obuna bo'lgan kurslar mavjud emas."}
        </div>
      )}
    </div>
  );
}
